import React from "react";
import QuizContainer from "../../components/Quiz/QuizContainer";
import { QuizHeader } from "../../components/Quiz/QuizHeader";
import useAuth from "../../utils/useAuth";
import styled from "@emotion/styled";
import { ExcellentCard } from "../../components/Quiz/ExcellentCard";
import SummaryScoreItem from "../../components/Quiz/SummaryScoreItem";
import { useState } from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import { getSummaryScore } from "../../utils/toPercent";
import { Navigate } from "react-router-dom";

export const QuizSummaryScore = () => {
  const { firstname, nickname, username } = useAuth();

  const [quizCategories, setQuizCategories] = useState([]);

  const [summaryScore, setSummaryScore] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const getName = () => {
    let name = firstname;
    if (name && nickname) {
      name += ` (${nickname})`;
    } else {
      name = username;
    }

    return name;
  };

  useEffect(() => {
    setSummaryScore(getSummaryScore(quizCategories.map((q) => q.score)));
  }, [quizCategories]);

  useEffect(() => {
    api
      .get("/quiz/getQuizHistories")
      .then((res) => {
        if (res.status === 200) setQuizCategories(res?.data?.quizHistories);
        setIsLoading(false);
      })
      .catch((err) => {
        alert("ไม่สามารถดึงข้อมูลรายการแบบทดสอบได้");
        setIsLoading(false);
      });
  }, []);

  const haveDoQuiz = () => {
    if (!quizCategories.length) return false;
    for (let i = 0; i < quizCategories.length; ++i) {
      if (quizCategories[i].totalFinish > 0) return true;
    }
    return false;
  };

  const isExcellent = () => {
    if (!quizCategories.length) return false;

    for (let i = 0; i < quizCategories.length; ++i) {
      if (quizCategories[i].score < 8) return false;
    }

    return true;
  };

  return (
    <>
      {!isLoading && (
        <>
          {haveDoQuiz() ? (
            <QuizContainer>
              <center>
                <QuizHeader>
                  สรุปคะแนนแบบทดสอบ ชุดความรู้เณรกล้า โภชนาดี
                </QuizHeader>
                <NameText>{getName()}</NameText>

                <SummaryScoreContainer>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    คะแนนสะสม&nbsp;&nbsp;&nbsp;
                    <span>{summaryScore}</span>
                  </div>
                  <div>
                    <span>
                      {summaryScore}
                      &nbsp;&nbsp;%
                    </span>
                  </div>
                </SummaryScoreContainer>

                {isExcellent() && (
                  <ExcellentCard summaryScorePercent={summaryScore} />
                )}
              </center>
              <SummaryScoreList>
                {quizCategories.map((q, i) => (
                  <SummaryScoreItem {...q} />
                ))}
              </SummaryScoreList>
            </QuizContainer>
          ) : (
            <Navigate to="/quiz" />
          )}
        </>
      )}
    </>
  );
};

const SummaryScoreList = styled.div`
  margin-top: 24px;
`;

const NameText = styled.p`
  font-family: "Noto Sans Thai";
  font-weight: 700;
  font-size: 18px;
  color: #64748b;
`;

const SummaryScoreContainer = styled.div`
  display: flex;
  color: #fb633d;
  font-weight: 600;
  font-size: 18px;
  justify-content: space-between;

  span {
    font-size: 28px;
  }
`;
